import { submit, formValueSelector } from 'redux-form'
import { Modal } from '../../components/common'
import {
  PROCESS_REQUEST_FORM,
  PROCESS_REQUEST_STATUS_FIELD,
  DISPLAY_STATUS,
} from '../../constants/ApprovalRequestConstants'

const selector = formValueSelector(PROCESS_REQUEST_FORM)
const mapStateToProps = (state, ownProps) => {
  const { modalCloseFocusElem, reprocessApprovedInd = false } = ownProps
  const selectedStatus = selector(state, PROCESS_REQUEST_STATUS_FIELD)
  const { submitting } = state.processApprovalRequest

  return {
    selectedStatus,
    submitting,
    modalCloseFocusElem,
    reprocessApprovedInd,
  }
}

const ConfirmProcessApprovalRequestModal = ({
  selectedStatus,
  submitting,
  submit,
  modalCloseFocusElem,
  reprocessApprovedInd,
  onCloseAction,
}) => (
  <div>
    <Modal
      shouldCloseModal={submitting}
      modalCloseFocusElem={modalCloseFocusElem}
      onCloseAction={onCloseAction}
      headerTitle="Process Request"
      footerActions={[
        { buttonLabel: 'Cancel', isDismissable: true, isPrimary: false },
        {
          buttonLabel: 'Submit',
          isPrimary: true,
          onClick: () => submit(PROCESS_REQUEST_FORM),
          isDisabled: submitting,
        },
      ]}
    >
      <div>
        <p>
          {reprocessApprovedInd ? (
            <>
              Are you sure you want to process this approved exam request as &quot;
              {DISPLAY_STATUS[selectedStatus]}&quot;?
            </>
          ) : (
            <>
              Are you sure you want to process this request as &quot;
              {DISPLAY_STATUS[selectedStatus]}
              &quot;?
            </>
          )}
        </p>
      </div>
    </Modal>
  </div>
)

export default connect(mapStateToProps, { submit })(ConfirmProcessApprovalRequestModal)
